import { useEffect, useState } from "react";
import {
    Grid
} from '@mui/material';
import JsSIP from "jssip";
// import MainLayout from "../layouts/MainLayout";
import getLoggedInUser from "../utils/getLoggedInUser";
import LeftSidebar from "../components/common/LeftSidebar";
import MiddleSection from "../components/common/MiddleSection";
import RightSidebar from "../components/common/RightSidebar";
import IncomingCall from '../components/common/IncomingCall';
import CallPopup from '../components/common/CallPopup';
import Dialpad from "../components/common/Dialpad";

const Dashboard = () => {
    const [outboundNumber, setOutboundNumber] = useState("");
    const [callerName, setCallerName] = useState("");
    const [callerNumber, setCallerNumber] = useState("");
    const [incomingCall, setIncomingCall] = useState(false);
    const [callAnswered, setCallAnswered] = useState(false);
    const [callPopupIsVisible, setCallPopupIsVisible] = useState(false);
    const [type, setType] = useState("");
    const [isMute, setIsMute] = useState(false);
    const [isHold, setIsHold] = useState(false);

    const [dialpadIsVisible, setDialpadIsVisible] = useState(false);

    const [session, setSession] = useState(null);
    const [userAgent, setUserAgent] = useState(null);
    const incomingCallRing = require('../assets/sounds/incoming.mp3');
    var ringtone = new Audio(incomingCallRing);
    ringtone.loop = true;

    // Define event handlers for the call
    var eventHandlers = {
        'progress': function (e) {
            console.log('Call is in progress');
        },
        'failed': function (e) {
            if (e.data && e.data.cause) {
                console.log('Call failed with cause: ' + e.data.cause);
            } else {
                console.log('Call failed');
            }
        },
        'ended': function (e) {
            if (e.data && e.data.cause) {
                console.log('Call ended with cause: ' + e.data.cause);
            } else {
                console.log('Call ended');
            }
        },
        'confirmed': function (e) {
            console.log('Call confirmed');
            setCallAnswered(true);
        }
    };
    const options = {
        'eventHandlers': eventHandlers,
        'mediaConstraints': { 'audio': true, 'video': true },
        'pcConfig': {
            'iceServers': [
                {
                    'urls': ['stun:stun.l.google.com:19302', 'stun:stun1.l.google.com:19302']
                }
            ]
        }
    };

    useEffect(() => {
        if (localStorage.getItem("userToken")) {
            console.log("logged in user", getLoggedInUser());
            const socket = new JsSIP.WebSocketInterface(`wss://${getLoggedInUser()?.webRTCDomain}:${getLoggedInUser()?.webRTCPort}`);

            const configuration = {
                sockets: [socket],
                uri: `sip:${getLoggedInUser()?.sipUsername}@${getLoggedInUser()?.webRTCServer}`,
                authorization_user: getLoggedInUser()?.sipUsername,
                password: getLoggedInUser()?.sipPassword,
                session_timers: false,
                "use_preloaded_route": false,
                "pcConfig": {
                    "rtcpMuxPolicy": "negotiate",
                    "iceServers": [{ "urls": ["stun:stun.l.google.com:19302"] }]
                },
            };
            JsSIP.debug.enable('JsSIP:*');
            let tempUserAgent = new JsSIP.UA(configuration);
            tempUserAgent.start();

            // Event handler for incoming calls
            tempUserAgent.on('newRTCSession', (incomingSession) => {
                console.log('Incoming call1');
                setSession(incomingSession.session);
                if (incomingSession?.session?.direction === 'incoming') {
                    console.log('Incoming call2');
                    // Show pop-up for incoming call
                    if (incomingSession.session) {
                        setIncomingCall(true);
                    }
                    else {
                        setIncomingCall(false);
                    }
                    // play ringtone
                    // playRingtone();
                }
            });
            // Event listener for 'connected' event
            tempUserAgent.on('connected', () => {
                console.log('Connected to the server');
            });
            // Event listener for 'registered' event
            tempUserAgent.on('registered', () => {
                console.log('Registration successful');
            });
            // Event listener for 'registrationFailed' event
            tempUserAgent.on('registrationFailed', (data) => {
                console.log('Registration failed:', data.cause);
            });
            // Event handler for call ended
            tempUserAgent.on('bye', () => {
                console.log('Call ended');
                // Hide keypad and disable buttons
                // document.getElementById('keypad').style.display = 'none';
                // document.getElementById('muteButton').disabled = true;
                // document.getElementById('holdButton').disabled = true;
                // Disable end call button
                // document.getElementById('endCall').disabled = true;
            });
            setUserAgent(tempUserAgent);
        }
    }, [localStorage.getItem("userToken")]);

    // // Function to play the ringtone
    const playRingtone = () => {
        // Check if the ringtone is already playing
        console.log("play ringtone paused", ringtone.paused);
        if (ringtone?.paused) {
            // Start playing the ringtone
            console.log("Start playing the ringtone");
            const playPromise = ringtone.play();

            if (playPromise !== undefined) {
                playPromise.then(() => {
                    console.log("Ringtone played successfully");
                }).catch(error => {
                    console.error("Failed to play ringtone:", error);
                });
            }
        }
    }

    // // Function to stop the ringtone
    const stopRingtone = () => {
        // Check if the ringtone is playing
        console.log("stop ringtone paused", ringtone.paused);
        if (!ringtone.paused) {
            // Stop the ringtone
            console.log("stop ringtone");
            ringtone.pause();
            ringtone.currentTime = 0; // Reset to beginning for next play
        }
    }

    const onAnswerCall = () => {
        // Event handler for answer call button
        console.log('Answering call');
        // stopRingtone();

        session?.answer(options);
        setCallAnswered(true);
        setCallPopupIsVisible(true);
        setType("incoming");

        session?.connection.addEventListener('addstream', function (e) {
            // Handle the addition of a new stream
            var remoteAudio = new Audio();
            remoteAudio.srcObject = e.stream;
            remoteAudio.play();
        });
    }

    const toggleMute = () => {
        if (session?.isMuted().audio) {
            console.log('Unmuting');
            session?.unmute({ audio: true });
            setIsMute(false);
            // document.getElementById('muteButton').innerText = 'Mute';
        } else {
            console.log('Muting');
            session?.mute({ audio: true });
            setIsMute(true);
            // document.getElementById('muteButton').innerText = 'Unmute';
        }
        setSession(session);
    }

    const toggleHold = () => {
        if (session?.isOnHold().local) {
            console.log('Unholding');
            session?.unhold();
            setIsHold(false);
            // document.getElementById('holdButton').innerText = 'Hold';
        } else {
            console.log('Holding');
            session?.hold();
            setIsHold(true);
            // document.getElementById('holdButton').innerText = 'Unhold';
        }
    }

    const onHangupCall = () => {
        console.log('Ending call');
        // Terminate the call
        if (session) {
            session?.terminate();
        }
        // stopRingtone();
        setCallAnswered(false);
        setCallPopupIsVisible(false);
        setIncomingCall(false);
    }

    const dialCall = (callType, number, outboundCallerNumber, callerName) => {
        setDialpadIsVisible(false);
        setCallerName(callerName);
        setCallerNumber(number);
        console.log('Making call');
        const extraHeaders = [
            `X-callType: ${callType}`,
            `X-sourceNumber: ${outboundCallerNumber}`
        ];
        console.log('extraHeaders', extraHeaders);
        options.extraHeaders = extraHeaders;
        console.log('options', options);
        let temp_session = userAgent.call(number, options);
        // Get the RTCPeerConnection object from the JsSIP session
        temp_session.connection.addEventListener('addstream', function (e) {
            // Handle the addition of a new stream
            var remoteAudio = new Audio();
            remoteAudio.srcObject = e.stream;
            remoteAudio.play();
        });
        setSession(temp_session);
        setType("outgoing");
        setCallPopupIsVisible(true);
        // Attach outgoing audio stream to audio element
        //outgoingAudio.srcObject = session.connection.getLocalStreams()[0];
        // Enable end call button
        // document.getElementById('endCall').disabled = false;
    }

    const sendDTMF = (digit) => {
        console.log('Sending DTMF: ' + digit);
        session?.sendDTMF(digit);
    }

    const onNumberSelected = (number) => {
        setOutboundNumber(number);
    }

    const onCloseDialpad = () => {
        setDialpadIsVisible(false);
    }

    return (
        // <MainLayout>
        <Grid container>
            <Grid xs={3}>
                <LeftSidebar
                    outboundNumber={outboundNumber}
                    onNumberSelected={onNumberSelected}
                    setDialpadIsVisible={setDialpadIsVisible}
                />
            </Grid>
            <Grid xs={6}>
                <MiddleSection />
            </Grid>
            <Grid xs={3}>
                <RightSidebar
                    dialCall={dialCall}
                    outboundNumber={outboundNumber}
                />
            </Grid>
            {
                incomingCall && (
                    <IncomingCall
                        // session={session}
                        // callAnswered={callAnswered}
                        onAnswerCall={onAnswerCall}
                        onHangupCall={onHangupCall}
                        callerName={callerName}
                        callerNumber={callerNumber}
                    // toggleMute={toggleMute}
                    // toggleHold={toggleHold}
                    />
                )
            }
            {
                callPopupIsVisible && (
                    <CallPopup
                        session={session}
                        callAnswered={callAnswered}
                        onAnswerCall={onAnswerCall}
                        onHangupCall={onHangupCall}
                        toggleMute={toggleMute}
                        toggleHold={toggleHold}
                        type={type}
                        callerName={callerName}
                        callerNumber={callerNumber}
                        sendDTMF={sendDTMF}
                        isMute={isMute}
                        isHold={isHold}
                    />
                )
            }
            {
                dialpadIsVisible && (
                    <Dialpad
                        outboundNumber={outboundNumber}
                        onNumberSelected={onNumberSelected}
                        onCloseDialpad={onCloseDialpad}
                        dialCall={dialCall}
                    />
                )
            }
        </Grid>
        // </MainLayout>
    )
}

export default Dashboard;